<template>
  <div class="tip-wapper">
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide img-wrap" v-for="(slide, i) in data.picture" :key="i">
          <img class="ev-img" :src="slide">
        </div>
      </div>
    </div>
    <div class="text" v-if="data.desc">
      {{ data.desc }}
    </div>
  </div>
</template>

<style type="text/css" scoped>
.text {
    padding: 15px;
}
.tip-wapper {
  width: 100%;
}

.img-wrap {
  position: relative;
  height: 0;
  width: 100%;
  padding-top: 57.89%;
}

.ev-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
</style>

<script type="text/javascript">
import Vue from 'vue';

if (process.env.VUE_ENV !== 'server') {
  require('swiper/dist/css/swiper.css');
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
  Vue.use(VueAwesomeSwiper);
}

export default {
  props: {
    data: Object
  },
  data () {
    return {
      swiperOption: {
        observeParents: true,
        observer: true
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/core/evaluate/evaluate-tip/evaluate-tip.vue